/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive} from '@angular/core';
export class IconCustomTag {
    // No behavior
    // The only purpose is to "declare" the tag in Angular
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-icon"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function IconCustomTag_tsickle_Closure_declarations() {
/** @type {?} */
IconCustomTag.decorators;
/**
 * @nocollapse
 * @type {?}
 */
IconCustomTag.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
